import "./navi-bootstrap.scss";

$(document).ready(() => {
    // script for msls Nav
    $('.dropdown-menu a').addClass('dropdown-item');
  
});